// import external dependencies
import 'jquery';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-fullscreen';
import 'masonry-layout';
import 'owl.carousel2';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_lg-fullscreen.js'; import './autoload/_lg-thumbnail.js'; import './autoload/_lightgallery.js'; import './autoload/_masonry-layout.js'; import './autoload/_owlcarousel.js'

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faPinterestP } from '@fortawesome/free-brands-svg-icons/faPinterestP';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { 
  faHeart as fasHeart, 
  faExpandAlt as fasExpandAlt, 
  faLongArrowAltDown as fasLongArrowAltDown, 
  faFilter as fasFilter, 
  faBars as fasBars, 
} from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(
  faHeart, 
  fasHeart, 
  fasExpandAlt, 
  fasLongArrowAltDown, 
  fasFilter, 
  fasBars, 
  faFacebookF, 
  faInstagram, 
  faPinterestP,
  faLinkedinIn);

// const heart = icon({ prefix: 'fa', iconName: 'heart' })
// const solid_heart = icon({ prefix: 'fas', iconName: 'heart' })
// const solid_expand_alt = icon({ prefix: 'fas', iconName: 'expand-alt' })
// const solid_cloud_download_alt = icon({ prefix: 'fas', iconName: 'cloud-download-alt' })

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js